import React from 'react';

/**
 * Off-screen text inside links/buttons so crawlers (e.g. Semrush anchor-text checks) and
 * assistive tech receive a text alternative without changing layout.
 */
const visuallyHiddenStyle: React.CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0,0,0,0)',
  whiteSpace: 'nowrap',
  border: 0,
};

export const VisuallyHiddenText: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className="apt-visually-hidden" style={visuallyHiddenStyle}>
    {children}
  </span>
);

export default VisuallyHiddenText;
